<template>

	<!-- Pannello Download in progress -->
	<v-card elevation="2" class="download-popup pr-1" dark>
		
		<div class="download-popup-header mb-1">
			<div><b>Download file</b></div>
			<v-btn
				text
				small
				color="primary"
				v-if="showCloseButton"
				v-on:click="closePopup">
				Chiudi
			</v-btn>

			<v-btn
				text
				small
				color="primary"
				v-if="!showCloseButton && Object.keys(this.listDownload).length > 0"
				v-on:click="cancelAll">
				Annulla tutti
			</v-btn>
		</div>

		<div class="download-popup-content">
			<div class="download-item py-2"
				v-for="(download, key) in listDownload"
				v-bind:key="key">

				<div class="download-item-row">
					<div class="download-item-part pt-1">
						<div>{{ download.name }}</div>
					</div>

					<div class="download-item-part download-item-part-column pt-1">
						<!-- Pannello Error / Attesa / Progress Bar -->
						<div>
							<!-- queued -->
							<div v-if="download.status == 'queued'" class="download-msg download-queued">
								<div>{{ download.progress }}</div>
							</div>

							<!-- error -->
							<div v-else-if="download.status == 'error'" class="download-msg download-error">
								<div>{{ download.progress }}</div>
								<v-icon class="ml-2">mdi-alert</v-icon>
							</div>

							<!-- in progress -->
							<v-progress-linear v-else
								v-model="download.progress"
								height="20">
								<template v-slot:default="{ value }">
									<strong>{{ value }}</strong>
								</template>
							</v-progress-linear>
						</div>

						<!-- Pannello Size + Speed -->
						<div v-if="download.status != 'queued' && download.status != 'error'" class="download-item-row pt-1">
							<div>{{ download.progressSize }}</div>
							<div>{{ download.speed }}</div>
						</div>
					</div>

					<!-- Delete Button -->
					<div>
						<v-btn
							icon
							@click="cancelDownload(key)">
							<v-icon>mdi-close-circle-outline</v-icon>
						</v-btn>
					</div>
				</div>
				
			</div>
		</div>

	</v-card>

</template>

<style>

	.download-popup {
		position: fixed;
		bottom: 11px;
		max-height: 250px;
		right: 0;
		margin-right: 20px;
		z-index: 10;
		padding: 10px;
		min-width: 40%;
		/* height: 100%; */
		display: flex;
		flex-direction: column;
		font-size: 0.8em !important;
	}

	.download-popup-header {
		display: flex;
		justify-content: space-between;
	}

	.download-popup-content {
		flex: 1;
		/* height: calc(100% - 28px); */
		overflow-y: auto;
	}

	.download-item {
		display: flex;
		flex-direction: column;
		border-bottom: 1px dotted #000000;
	}
	.download-item-row {
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
	}
	.download-item-part {
		flex: 1;
		padding-right: 10px;
	}
	.download-item-part-column {
		display: flex;
		flex-direction: column;
	}
	
	.download-msg {
		display: flex;
		justify-content: flex-end;
	}
	.download-queued {
		color: #00dd00;
	}
	.download-error {
		color: #ff5858;
	}
	.download-error i {
		color: #e12424 !important;
	}

	div.download-popup-content::-webkit-scrollbar {
		width: 12px !important;
	}
  
	div.download-popup-content::-webkit-scrollbar-track {
		background: #202020;
		border-left: 1px solid #2c2c2c;
	}
	
	div.download-popup-content::-webkit-scrollbar-thumb {
		background: #5a5a5a;
		border: solid 3px #202020;
		border-radius: 7px;
	}
	
	div.download-popup-content::-webkit-scrollbar-thumb:hover {
		background: #707070;
	}

</style>

<script>
const { RequestsUtils } = require("@/assets/js/scripts/utils/RequestsUtils");
const { Utils } = require('@/assets/js/scripts/utils/Utils');

import axios from 'axios';
const qs = require('qs');

export default {
	name: 'FileDownloader',
	props: [
		'prop_list_download', // Lista oggetto con url e nome file
	],

	data() {
		return {
			listDownload: {},
			showCloseButton: false,
		}
	},

	methods: {
		downloadFile(downloadUrl, id, name) {

			let data = {
				id: id
			};

			// Controller per ventuale abort 
			this.listDownload[id].controller = new AbortController();

			let configs = {
				params: data,
				signal: this.listDownload[id].controller.signal,
				headers: {
					'Content-Type': "application/x-www-form-urlencoded"
				},
				responseType: 'blob',
				onDownloadProgress: (progressEvent) => {

					
					let contentLen = progressEvent.srcElement.getResponseHeader('X-Actual-Content-Lenght');
					if (Utils.isNullOrUndefined(contentLen)) {
						return;
					}

					this.listDownload[id].count++;

					let totalLength = parseInt(contentLen);

					let curTime = Date.now();
					let curSize = progressEvent.loaded;
					let percentCompleted = Math.round((curSize * 100) / totalLength);
					let speed = this.listDownload[id].speed;
					if(!speed || Utils.isMultiple(this.listDownload[id].count, 10)) {
						speed = Utils.getTransferSpeed(curTime, this.listDownload[id].prevTime, curSize, this.listDownload[id].prevSize);
					}

					let curSizeHuman = Utils.humanFileSize(curSize);
					let totSizeHuman = Utils.humanFileSize(totalLength);

					if(curSizeHuman.unit === totSizeHuman.unit) {
						curSizeHuman.unit = "";
					}
					
					this.listDownload[id].progress = percentCompleted + " %";
					this.listDownload[id].progressSize = curSizeHuman.value + "" + curSizeHuman.unit + "/" + totSizeHuman.value + "" + totSizeHuman.unit;
					this.listDownload[id].speed = speed;
					this.listDownload[id].status = 'in_progress';
					this.listDownload[id].prevTime = curTime;
					this.listDownload[id].prevSize = curSize;

					this.$forceUpdate();
					
				}
			}

			//axios(configs)
			axios.get(downloadUrl, configs)
			.then(response => {
				const type = response.headers['content-type'];
				//const blob = new Blob([response.data], { type: type, encoding: 'UTF-8' });
				const blob = new Blob([response.data]);
				const url = window.URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.href = url;
				const fileName = name // whatever your file name .
				link.setAttribute('download', fileName);
				document.body.appendChild(link);
				link.click();
				link.remove();

				// Rimuove item dalla lista file download
				delete this.listDownload[id];
				this.checkIfFinished();
				this.$forceUpdate();
			})
			.catch(error => {
				console.error(error);

				if(this.listDownload[id] == undefined) {
					return;
				}

				/*
				Marco download come error
				*/
				this.listDownload[id].status = 'error';
				this.listDownload[id].progress = 'Errore';

				if(error.message && error.message == "canceled") {
					this.listDownload[id].status = 'canceled';
					this.listDownload[id].progress = 'Annullato';
					delete this.listDownload[id];
				}
				this.$forceUpdate();
				this.checkIfFinished();
			});
		},

		cancelAll() {
			if(Object.keys(this.listDownload).length > 0) {
				for(let id in this.listDownload) {
					this.cancelDownload(id);
				}
			}
		},

		cancelDownload(id) {
			if(this.listDownload[id].controller != undefined) {
				this.listDownload[id].controller.abort();
			}

			delete this.listDownload[id];
			this.$forceUpdate();

			if(Object.keys(this.listDownload).length == 0) {
				this.closePopup();
				console.log('Tutto annullato..');
			}
		},

		checkIfFinished() {
			/*
			Se sono tutti finiti --> download completed
			*/
			if(Object.keys(this.listDownload).length == 0) {
				this.$emit('download_completed');
			}
			/*
			Se sono tutti finiti ma almeno un errore -> non chiudo ma mostro pulsante
			*/
			let inprogressItems = 0;
			let errorItems = 0;
			let queuedItems = 0;
			for (const k in this.listDownload) {
				if (this.listDownload[k].status === 'in_progress') {
					inprogressItems++;
				}
				if (this.listDownload[k].status === 'error') {
					errorItems++;
				}
				if (this.listDownload[k].status === 'queued') {
					queuedItems++;
				}
			}
			if (queuedItems == 0 && inprogressItems == 0 && errorItems > 0) {
				this.showCloseButton = true;
			}
		},

		closePopup() {
			this.showCloseButton = false;
			this.$emit('download_completed');
		}
	},

	watch: {
		prop_list_download: {
			immediate: true,
			handler(val, oldVal) {
				this.showCloseButton = false;
				if(val != null && val.length > 0) {
					val.forEach((element) => {
						if(this.listDownload[element.id] == undefined) {
							this.listDownload[element.id] = {
								name: element.name,
								url: element.url,
								progress: "In attesa",
								status: 'queued',
								count: 0
							};

							this.downloadFile(element.url, element.id, element.name);
						}
					});
				}
			}
		},
	}
}
</script>